import { render } from "./index.vue?vue&type=template&id=3aa797f7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/updsh/risk-manager-ui/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__